'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002491 from "./presto.-Presto-Router$$anon$91.js";
import * as $j_presto$002e$002dRegister$002dDirective$002dPage$0024 from "./presto.-Register-Directive-Page$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$90() {
  this.bof = null;
  this.bo7 = null;
  this.bo8 = false;
  this.bog = null;
  this.boh = false;
  this.bok = null;
  this.bod = null;
  this.boe = false;
  this.bo9 = null;
  this.boa = false;
  this.bob = null;
  this.boc = false;
  this.boi = false;
  this.boj = false;
  this.bof = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bok = "RegisterDirectivePage";
}
export { $c_Lpresto_PrestoRouter$$anon$90 as $c_Lpresto_PrestoRouter$$anon$90 };
$p = $c_Lpresto_PrestoRouter$$anon$90.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$90;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$90() {
}
export { $h_Lpresto_PrestoRouter$$anon$90 as $h_Lpresto_PrestoRouter$$anon$90 };
$h_Lpresto_PrestoRouter$$anon$90.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bof;
});
$p.M = (function() {
  if ((!this.bo8)) {
    this.bo7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bo8 = true;
  }
  return this.bo7;
});
$p.O = (function() {
  if ((!this.boh)) {
    this.bog = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.boh = true;
  }
  return this.bog;
});
$p.E = (function() {
  return this.bok;
});
$p.t = (function() {
  if ((!this.boe)) {
    this.bod = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("url", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("selector", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.boe = true;
  }
  return this.bod;
});
$p.N = (function() {
  if ((!this.boa)) {
    this.bo9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fb(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.boa = true;
  }
  return this.bo9;
});
$p.Q = (function() {
  if ((!this.boc)) {
    this.bob = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002491.$c_Lpresto_PrestoRouter$$anon$91();
    this.boc = true;
  }
  return this.bob;
});
$p.v = (function() {
  if ((!this.boj)) {
    this.boi = false;
    this.boj = true;
  }
  return this.boi;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee576) => ((p) => \u03b4scrutinee576.cFB(p)))($j_presto$002e$002dRegister$002dDirective$002dPage$0024.$m_Lpresto_RegisterDirectivePage$())));
});
var $d_Lpresto_PrestoRouter$$anon$90 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$90, "presto.PrestoRouter$$anon$90", ({
  P9: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$90 as $d_Lpresto_PrestoRouter$$anon$90 };
//# sourceMappingURL=presto.-Presto-Router$$anon$90.js.map
